import { keepPreviousData } from '@tanstack/react-query';

import { SynapseProblemID } from '@playq/octopus2-ml';
import { GenericFailure } from '@playq/services-shared';
import { SynapseProblemSchemaSampleJson } from '@playq/services-synapse';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const problemSchemaSampleKeys: unknown[] = ['problem', 'schema', 'sample'];
export const useProblemSchemaSampleJSON = (
  id: SynapseProblemID,
  version?: number,
  options?: IUseQueryOptionsExtended<SynapseProblemSchemaSampleJson | undefined, GenericFailure | Error>
) =>
  useEitherQuery(
    problemSchemaSampleKeys.concat(id, version),
    () => {
      if (version !== undefined) {
        return services2.synapseProblemsService.problemSchemaSampleJson(id, version);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
